import { ListItemDTO, MenuItemDTO, DashboardNavClient, NavItemDTO } from "@/Generated/ParticaAPI";


export interface INavigationService {
	getIssuesForStream(contentStreamId: number): Promise<ListItemDTO[]>;
	getLevelsForStream(contentStreamId: number): Promise<ListItemDTO[]>;
	getMenu(accountid: number, currentid: number): Promise<MenuItemDTO[]>;
	getMyMenu(): Promise<MenuItemDTO[]>;
	searchArticlesAll(issueId: number): Promise<ListItemDTO[]>;
	getWesbitesForAccount(customerAccountId: number): Promise<ListItemDTO[]>;
	getAccounts(query: string): Promise<ListItemDTO[]>;
	getAccount(id: number): Promise<NavItemDTO>;
	getStream(id: number): Promise<NavItemDTO>;
	getPublication(id: number): Promise<NavItemDTO>;
	getIssue(id: number): Promise<NavItemDTO>;
	getDomain(id: number): Promise<NavItemDTO>;
	GetNavData(id: number, type: string, accountId: number): Promise<NavItemDTO>;
	getArticlesForStreamSubscription(subscriptionId: number): Promise<ListItemDTO[]>;
}
export class NavigationService implements INavigationService {
	private svc: DashboardNavClient = new DashboardNavClient();

	public async getArticlesForStreamSubscription(subscriptionId: number): Promise<ListItemDTO[]> {
		return await this.svc.getSubscriptionArticles(subscriptionId, true);
	}

	public async getWesbitesForAccount(customerAccountId: number): Promise<ListItemDTO[]> {
		return await this.svc.getDomains(customerAccountId);
	}
	public async getAccounts(query: string): Promise<ListItemDTO[]> {
		return await this.svc.getAccounts(query);
	}
	public async getLevelsForStream(contentStreamId: number): Promise<ListItemDTO[]> {
		return await this.svc.getPricingLevelsForStream(contentStreamId);
	}

	public async getIssuesForStream(contentStreamId: number): Promise<ListItemDTO[]> {
		return await this.svc.getIssuesForStream(contentStreamId);
	}
	public async getMenu(accountId: number, currentId: number): Promise<MenuItemDTO[]> {
		if (currentId > 0) {
			return await this.svc.getDashboardMenu(currentId);
		} else if (accountId > 0) {
			return await this.svc.getDashboardMenu(accountId);
		}
		throw new Error("Error fetching menu. No account specified.");
	}
	public async getMyMenu(): Promise<MenuItemDTO[]> {
		return await this.svc.getMe();
	}
	public async searchArticlesAll(issueId: number): Promise<ListItemDTO[]> {
		return await this.svc.searchArticlesAll(issueId);
	}

	public async getAccount(Id: number): Promise<NavItemDTO> {
		return await this.svc.getAccount(Id);
	}
	public async getIssue(Id: number): Promise<NavItemDTO> {
		return await this.svc.getIssue(Id);
	}
	public async getPublication(Id: number): Promise<NavItemDTO> {
		return await this.svc.getPublication(Id);
	}
	public async getStream(Id: number): Promise<NavItemDTO> {
		return await this.svc.getStream(Id);
	}
	public async getDomain(Id: number): Promise<NavItemDTO> {
		return await this.svc.getUrl(Id);
	}
	public async GetNavData(id: number, type: string, accountId: number): Promise<NavItemDTO> {
		switch (type) {
			case "issue": {
				return await this.svc.getIssue(id);
			}
			case "publication": {
				return await this.svc.getPublication(id);
			}
			case "stream": {
				return await this.svc.getStream(id);
			}
			case "streamsub": {
				return await this.svc.getStreamSubscription(id);
			}
			case "account": {
				return await this.svc.getAccount(id);
			}
			case "website": {
				return await this.svc.getUrl(id);
			}
			case "admin": {
				if (accountId > 0) {
					return await this.svc.getAccount(accountId);
				}
				break;
			}
			default: {
				throw new Error("Invalid page type.");
			}
		}
		return new NavItemDTO();
	}

}
